import Grid from '@mui/material/Grid'
import React, { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import { HHFormTextField } from 'components/form-fields/v5'
import T from 'T'

import NewAccountDetailsFields from './NewAccountDetailsFields'
import NewAccountLocationFields from './NewAccountLocationFields'

import type { NewAccountFormValues } from './model'
import type { NewAccountLifecycle } from './useNewAccountLifecycle'
import type { LatLng, LatLngHistory } from './useNewAccountMap'

type NewAccountFieldsProps = {
  lifecycle: NewAccountLifecycle
  onEnter: () => void
  setLatLngForMap: React.Dispatch<React.SetStateAction<LatLng>>
  setLatLngForMapHistory: React.Dispatch<React.SetStateAction<LatLngHistory>>
}

const NewAccountFields = ({ lifecycle, onEnter, setLatLngForMap, setLatLngForMapHistory }: NewAccountFieldsProps) => {
  const { control } = useFormContext<NewAccountFormValues>()

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        onEnter()
      }
    },
    [onEnter]
  )

  return (
    <Grid container height="fit-content" rowGap={1.5} size={12} sx={{ width: '100%' }}>
      <NewAccountDetailsFields lifecycle={lifecycle} onKeyDown={handleKeyDown} />
      <NewAccountLocationFields
        setLatLngForMap={setLatLngForMap}
        setLatLngForMapHistory={setLatLngForMapHistory}
        onKeyDown={handleKeyDown}
      />
      <Grid size={12}>
        <HHFormTextField
          fullWidth
          multiline
          control={control}
          deprecatedLabel={false}
          label={T.ACCOUNT_NOTE}
          maxRows={6}
          minRows={2}
          name="note"
          placeholder={T.OPTIONAL_NOTES}
        />
      </Grid>
    </Grid>
  )
}

export default NewAccountFields
